import { matchPath } from 'react-router-dom';
import {
  EDIT_QUESTION_POPUP_ACTION_SOURCE,
  FINANCE_INTAKE_PAGE_ACTION_SOURCE,
  INTAKE_PAGE_ACTION_SOURCE,
  FEED_PAGE_TREATMENT_WIDGET_ACTION_SOURCE,
  PROFILE_TREATMENTS_ACTION_SOURCE,
  ADD_TREATMENTS_PROFILE_ACTIONS_ACTION_SOURCE,
  INTAKE_POPUP_ACTION_SOURCE,
} from 'utils/constants/actionSource';
import { BACKDROP_TYPES } from 'modules/backdrop/constants';
import {
  DASHBOARD_ROUTES, PAGE_LAYOUT_ROUTES, ROUTE_NAME, ROUTE_PATH,
} from 'utils/constants/router';
import { getFirstMatchedRoute } from 'functions/getFirstMatchedRouteName';

const ROUTES_TO_HIDE_FOOTER_RULE = [
  {
    path: ROUTE_PATH[ROUTE_NAME.SIGN_UP],
    shouldHide: ({ provider }) => !provider,
  },
  {
    path: ROUTE_PATH[ROUTE_NAME.QUESTIONNAIRE],
    shouldHide: ({ isMobile, provider, isQuestionnaireInitialized }) => (
      (provider ? false : isMobile) || isQuestionnaireInitialized
    ),
  },
];

const USER_UPDATE_ACTION_SOURCES_TO_LOADER_IGNORE = [
  INTAKE_PAGE_ACTION_SOURCE,
  INTAKE_POPUP_ACTION_SOURCE,
  FINANCE_INTAKE_PAGE_ACTION_SOURCE,
  EDIT_QUESTION_POPUP_ACTION_SOURCE,
  FEED_PAGE_TREATMENT_WIDGET_ACTION_SOURCE,
  PROFILE_TREATMENTS_ACTION_SOURCE,
  ADD_TREATMENTS_PROFILE_ACTIONS_ACTION_SOURCE,
];

const shouldHideFooter = ({
  pathname, isMobile, provider, isQuestionnaireInitialized,
}) => ROUTES_TO_HIDE_FOOTER_RULE.some(({ path, shouldHide }) => {
  const matched = matchPath(pathname, {
    path,
    exact: true,
    strict: true,
  });
  return matched && shouldHide({ isMobile, provider, isQuestionnaireInitialized });
});

export const getIsFooterShown = ({
  isDashboard, provider, pathname, isMobile, isQuestionnaireInitialized,
}) => {
  if (isDashboard) {
    return !!provider;
  }
  return !shouldHideFooter({
    pathname, isMobile, provider, isQuestionnaireInitialized,
  });
};

export const getBackdropTypeToShow = ({
  authentication: { isFormFetching: isLoginFormPending, isVerificationCodeFetching },
  userGet: { isFetching: isUserGetPending },
  userUpdate: { isFetching: isUserUpdatePending, updateSource: userUpdateSource },
  backdrop: { isShown: isBackdropShown, type: backdropType },
}) => {
  if (isBackdropShown) {
    return backdropType;
  }

  const isPreloaderBackdropShown = (isUserUpdatePending && !USER_UPDATE_ACTION_SOURCES_TO_LOADER_IGNORE.includes(userUpdateSource))
    || isUserGetPending
    || isLoginFormPending
    || isVerificationCodeFetching;

  return isPreloaderBackdropShown ? BACKDROP_TYPES.PRELOADER : null;
};

export const getIsDashboardRoute = (pathname) => !!getFirstMatchedRoute(DASHBOARD_ROUTES, pathname);

export const getIsPageLayoutRoute = (pathname) => !!getFirstMatchedRoute(PAGE_LAYOUT_ROUTES, pathname);
